{
    "contentTooLarge": "Content too large, please shorten it",
    "noticeBoard": "Notice Board",
    "manageNoticeBoard": "Manage Notice Board",
    "userType": "User Type",
    "viewAllNotices": "View All Notices",
    "exportToPDF": "Export to PDF",
    "copyQuestionBank": "Copy Question Bank",
    "subjectMapping":"Subject Mapping"
}